import * as CandidateRoute from './CandidateRoutes';
import CandidateContainer from '../containers/CandidateContainer';

export const CandidateRoutes = [
  {
    key: 'candidate',
    exact: true,
    path: CandidateRoute.CANDIDATE,
    component: CandidateContainer
  }
];
